/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

export enum Theme {
    LIGHT = 'light',
    DARK = 'dark'
}
